import { render, staticRenderFns } from "./project-setup.vue?vue&type=template&id=53ddf87a&"
import script from "./project-setup.vue?vue&type=script&lang=ts&"
export * from "./project-setup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports